export default __webpack_public_path__ + "static/media/grey-parrot-ai.67e83eca.mp4";